import { APICore } from './apiCore'

const api = new APICore()

function getAccommodations (params) {
  const baseUrl = '/accommodations'
  return api.get(baseUrl, params)
}

function getAccommodation (id) {
  const baseUrl = `/accommodations/${id}`
  return api.get(baseUrl, {})
}

function addAccommodation (params) {
  const baseUrl = '/accommodations'
  return api.create(baseUrl, params)
}

function updateAccommodation (params) {
  const baseUrl = '/accommodations'
  return api.update(baseUrl, params)
}

function deleteAccommodation (params) {
  const baseUrl = '/accommodations'
  return api.delete(baseUrl, params)
}

function getAccommodationCharts (params) {
  const baseUrl = '/accommodations/charts'
  return api.get(baseUrl, params)
}

function getAccommodationsForExcel (params) {
  const baseUrl = '/accommodations/excel'
  return api.get(baseUrl, params)
}

export { getAccommodations, getAccommodation, addAccommodation, updateAccommodation, deleteAccommodation, getAccommodationCharts, getAccommodationsForExcel }
